import { render, staticRenderFns } from "./LeisureProfile.vue?vue&type=template&id=4f17e152&scoped=true"
import script from "./LeisureProfile.vue?vue&type=script&lang=js"
export * from "./LeisureProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f17e152",
  null
  
)

export default component.exports